import { SELECTED_AIRPORT } from "../actions/airport";

const selctedAirports = [
    [
        { value: "THR", label: "Tehran" },
        { value: "SYZ", label: "Shiraz" },
        { value: "IFN", label: "Isfahan | Esfahan" },
        { value: "TBZ", label: "Tabriz" },
        { value: "KER", label: "Kerman" },
        { value: "GSM", label: "Qeshm Island" },
        { value: "BND", label: "Bandar Abbas" },
        { value: "KIH", label: "Kish Island" },
        { value: "MHD", label: "Mashhad" },
        { value: "RAS", label: "Rasht" }
    ]
    ,
    [
        { value: "ABD", label: "Abadan" },
        { value: "AEU", label: "Abu Musa Island" },
        { value: "AWZ", label: "Ahvaz" },
        { value: "AJK", label: "Arak" },
        { value: "ADU", label: "Ardabil" },
        { value: "YEH", label: "Asalouyeh (Asalouyeh Airport)" },
        { value: "PGU", label: "Asalouyeh (Persian Gulf Airport)" },
        { value: "BBL", label: "Babolsar" },
        { value: "IAQ", label: "Bahregan" },
        { value: "BXR", label: "Bam" },
        { value: "BDH", label: "Bandar Lengeh" },
        { value: "XBJ", label: "Birjand" },
        { value: "BJB", label: "Bojnord" },
        { value: "BUZ", label: "Bushehr" },
        { value: "ZBR", label: "Chabahar" },
        { value: "DEF", label: "Dezful" },
        { value: "FAZ", label: "Fasa" },
        { value: "GCH", label: "Gachsaran" },
        { value: "GBT", label: "Gorgan" },
        { value: "HDM", label: "Hamadan" },
        { value: "IIL", label: "Ilam" },
        { value: "IHR", label: "Iranshahr" },
        { value: "JAR", label: "Jahrom" },
        { value: "JSK", label: "Jask" },
        { value: "JYR", label: "Jiroft" },
        { value: "KLM", label: "Kalaleh" },
        { value: "KNR", label: "Kangan" },
        { value: "PYK", label: "Karaj" },
        { value: "KKS", label: "Kashan" },

        { value: "KSH", label: "Kermanshah" },
        { value: "KHA", label: "Khaneh" },
        { value: "KHK", label: "Kharg Island" },
        { value: "KHD", label: "Khorramabad" },
        { value: "KHY", label: "Khoy" },
        { value: "LFM", label: "Lamerd" },
        { value: "LRR", label: "Larestan" },
        { value: "LVP", label: "Lavan Island" },
        { value: "MRX", label: "Mahshahr" },
        { value: "ACP", label: "Maragheh (Sahand)" },
        { value: "NSH", label: "Noshahr" },
        { value: "PFQ", label: "Parsabad" },
        { value: "GZW", label: "Qazvin (Ghazvin)" },
        { value: "RJN", label: "Rafsanjan" },
        { value: "RZR", label: "Ramsar / Tonekabon" },
        { value: "AFZ", label: "Sabzevar" },
        { value: "SDG", label: "Sanandaj" },
        { value: "CKT", label: "Sarakhs" },
        { value: "SRY", label: "Sari" },
        { value: "CQD", label: "Shahrekord" },
        { value: "RUD", label: "Shahrood" },
        { value: "SYJ", label: "Sirjan" },
        { value: "SXI", label: "Sirri Island" },
        { value: "TCX", label: "Tabas" },
        { value: "OMH", label: "Urmia" },
        { value: "YES", label: "Yasuj" },
        { value: "AZD", label: "Yazd" },
        { value: "ACZ", label: "Zabol" },
        { value: "ZAH", label: "Zahedan" },
        { value: "JWN", label: "Zanjan" }
    ]
];



export default function airports(state = selctedAirports, action = {}) {
    switch (action.type) {
        case SELECTED_AIRPORT:
            return selctedAirports;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/selectedairports.js